import { combineReducers } from 'redux';
import { liveInstantBookReducer } from 'state/secondaryMarket/live/instantBook/instantBook.reducer';
import { initialLiveTradeMap } from 'state/secondaryMarket/live/trade/trade.model';
import { amendTradeReducerFactory } from 'state/secondaryMarket/shared/amend/amend.reducer';
import { cancellationReducerFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.reducer';
import { defaultReducerFactory } from 'state/secondaryMarket/shared/defaults/defaults.reducer';
import { kycReducerFactory } from 'state/secondaryMarket/shared/kyc/kyc.reducer';
import { tradeReducerFactory } from 'state/secondaryMarket/shared/trade/trade.reducer';
import { removeKey } from 'state/utils/collection';

import { liveFormReducer } from './form/liveForm.reducer';
import type { Live } from './live.model';
import { liveQuotesReducer } from './quote/liveQuote.reducer';
import { liveReferentialReducer } from './referential/liveReferential.reducer';

export const liveReducer = combineReducers<Live>({
  form: liveFormReducer,
  amend: amendTradeReducerFactory('LIVE'),
  referential: liveReferentialReducer,
  quotes: liveQuotesReducer,
  defaults: defaultReducerFactory('LIVE'),
  cancellations: cancellationReducerFactory('LIVE'),
  instantBook: liveInstantBookReducer,
  kyc: kycReducerFactory('LIVE', 'live'),
  trades: tradeReducerFactory('LIVE', initialLiveTradeMap, (state, action) => {
    switch (action.type) {
      case 'SECONDARY_MARKET_LIVE_QUOTE_CANCEL_REQUESTED':
      case 'SECONDARY_MARKET_LIVE_QUOTE_CLEARED':
        return removeKey(state, action.tabId);
      default:
        return state;
    }
  }),
});
